import CandidateOverviewForm from './CandidateOverviewForm.container';

export default CandidateOverviewForm;
